import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatsappImageRoutingModule } from './whatsapp-image-routing.module';
import { WhatsappImageComponent } from './whatsapp-image.component';
import { CommonFileUploadComponent } from 'src/app/global/common-file-upload/common-file-upload.component';
import { CommonImagesModule } from '../common-images/common-images.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    WhatsappImageComponent
  ],
  imports: [
    CommonModule,
    WhatsappImageRoutingModule,
    CommonFileUploadModule,
    FileUploadModule,
    CommonImagesModule,
    SharedModule
  ],
  exports:[
    WhatsappImageComponent
  ]
})
export class WhatsappImageModule { }
